import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UserCompanyService } from '../services/userCompany.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { PromoModalComponent, PromoModalData } from '../shared/promo-modal/promo-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { MareAuthService } from '@mare-common/ngx-mare-auth';
import { RoutingService } from '../services/routing.service';

@Component({
  selector: 'app-complete-profile',
  templateUrl: './complete-profile.component.html',
  styleUrls: ['./complete-profile.component.scss']
})
export class CompleteProfileComponent {

  completeProfileForm: FormGroup = new FormGroup({});
  user: any;

  constructor(
    private userCompanyService: UserCompanyService,
    private formBuilder: FormBuilder,
    private router: Router,
    private authService: MareAuthService,
    private dialog: MatDialog,
    private routingService: RoutingService
  ) {

  }
  ngOnInit(): void {
    this.initForm();
    this.userCompanyService.user$.subscribe((res: any) => {
      // console.log('user and company', res)
        this.user = res;
        this.updateForm(this.user)
    });
  }

  updateForm(user: any) {
    this.completeProfileForm.patchValue({
      name: user?.name,
      surname: user?.surname,
      phone: user?.phone,
      phone_prefix: '+39',
      website: user?.website,
    })
  }

  initForm() {
    this.completeProfileForm = this.formBuilder.group({
      name: new FormControl('', Validators.required),
      surname: new FormControl('', Validators.required),
      phone: new FormControl('', Validators.required),
      phone_prefix: new FormControl('+39', Validators.required),
      privacy: new FormControl(false, Validators.requiredTrue),
      tec: new FormControl(false, Validators.requiredTrue),
      website: new FormControl('', []),
    });
    // console.log(this.completeProfileForm)
  }

  submitForm() {
    // console.log(this.completeProfileForm.value);

    this.userCompanyService.updateUser(this.completeProfileForm.value).then((res: any) => {
      this.userCompanyService.updateMultipleUserCompanyInfo(this.completeProfileForm.value).then((res: any) => {
        // console.log('res', res)
        this.userCompanyService.retrieveUserCompany(true).catch(
          (err: any) => {
            console.log(err)
          }
        ).then((res: any) => {
          // console.log('res', res)
          // this.router.navigate([environment.routingBasePath + '/dashboard'])
          let redirect = this.routingService.getRedirect();
          if(redirect) {
            this.routingService.registerRedirect(null);
            if(redirect.startsWith('http')) {
              window.location.href = redirect;
            } else {
              this.router.navigate([redirect]);
            }
          } else {
            this.router.navigate([environment.routingBasePath + '/' + environment.routingLoginRedirect])
          }

        })
      })
    });
  }

  forceLogout() {

    let configModal: PromoModalData = {
      content: [{
        promo_title: 'Sei sicuro di voler uscire?',
        promo_text: 'Se non inserisci i dati del profilo non potrai accedere alla tua dashboard ma non preoccuparti, potrai completare il tuo profilo la prossima volta che proverai ad accedere.'
      }  
      ],
      buttons: [
        {
          text: 'Si esci',
          value: 'confirm'}
      ]
    }
    const dialog = this.dialog.open(PromoModalComponent, {
      width: '560px',
      maxWidth: '90vw',
      data: configModal
    })
    dialog.afterClosed().subscribe(result => {
      // console.log('clicked', result);
      if (result == 'confirm') {
        this.authService.logout();
      }
    });
  }

  

}
